import Handlebars from 'handlebars';
import Stammdaten from './Stammdaten';
require('jplist/new/jplist.core.min.js');
require('jplist/new/jplist.pagination-bundle.min.js');
require('jplist/new/jplist.sort-bundle.min.js');
require('jplist/new/jplist.filter-dropdown-bundle.min.js');
require('jplist/new/jplist.textbox-filter.min.js');

export default class Haendlerverwaltung {

    constructor( haendler) {
        this.element = $('#HaendlerContainer');
        this.subelement=$('#singleHaendlerContainer');
        this.added=null;
        this.haendlerlist=[];
        this.haendler = haendler;
        APP.haendler = haendler;
        this.multiTemplate = Handlebars.compile($('#manyHaendlerTemplate').html());
        if (this.haendler.superhaendler || APP.settings.userRole == 'admin') {
            this.loadHaendler();
        }
        $('#zurück',this.subelement).onSafe('tap',()=>{
            this.toggleVisibility();
            if (this.added){
                this.added.remove();
            }
            this.loadHaendler();
        });
    }

    toggleVisibility(){
        this.element.toggle();
        this.subelement.toggle();
     }

     editLogik(id){
        this.added=$('<div>').appendTo(this.subelement);
        new Stammdaten(this.added,this.haendlerlist.find(h=>h.id==id),true);
        this.toggleVisibility();
     }

     createLogik(){
         this.added=$('<div>').appendTo(this.subelement);
         new Stammdaten(this.added,{
             Gestellgruppe: this.haendler.Gestellgruppe,
             NutzeSonderplatten: this.haendler.NutzeSonderplatten,
             berechnungsfaktorGestelle: 1000,
             berechnungsfaktorPlatten: 1000
         },true);
         this.toggleVisibility();
     }

    loadHaendler() {
        let queryString = 'table=Haendler&where.parenthaendler=' + encodeURIComponent(this.haendler.loginname);
        if (APP.settings.userRole == 'admin') {
            queryString = 'table=Haendler';
        }

        APP.wkfgBackendApi.loadMetadata(queryString).then(a => {
            this.haendlerlist=a.Haendler||[];
            this.element.html(this.multiTemplate({
                list: this.haendlerlist
            }));
            $('.edit',this.element).onSafe('tap',(context,event)=>{
                const id=$(event.target).data('id');
                this.editLogik(id);
            });
            $('.createNew',this.element).onSafe('tap',()=>this.createLogik());
            this.element.jplist({
                itemsBox: '.haendlertable',
                itemPath: '.tblItem',
                panelPath: '.jplist-panel',
                noResults: '.noresultstable'
            });
        });

    }
}